import type { AgGrid } from "@jsq/ds/core";
import { HighlightText } from ".";

/**
 * AG Grid cell-renderer factory that wraps a field value in `<HighlightText>`
 * keyed off `context.searchValue`, so grids can highlight matches without
 * re-creating column defs on every keystroke. AG Grid caches cell renderers
 * by row id, so pair this with a `refreshCells({ force: true })` call on the
 * highlighted columns whenever the search term changes.
 */
export const makeHighlightRenderer = <TRow,>(
  getValue: (row: TRow) => string | undefined,
  opts?: { placeholder?: string },
) => {
  const HighlightCell = (params: AgGrid.ICellRendererParams<TRow>) => {
    if (!params.data) return null;
    const searchValue = (params.context as { searchValue?: string })?.searchValue ?? "";
    const value = getValue(params.data)?.trim() ?? "";
    if (!value) return <>{opts?.placeholder ?? ""}</>;
    return <HighlightText text={value} searchValue={searchValue} />;
  };
  HighlightCell.displayName = "GridHighlightCell";
  return HighlightCell;
};
